import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { CouponType } from "@interfaces/dto/coupon.dto";
import Detail from "./DetailModal";

type Props = {
  couponData: {
    coupon: string;
    name: string;
    campaign_name: string;
    description: string;
    from_date: string;
    to_date: string;
  } | null;
  screenSize?: number;
  isShow: boolean;
  handleCloseModal: () => void | undefined;
  selectedStatus: CouponType | undefined;
};

const CouponModal = ({
  couponData,
  isShow,
  handleCloseModal,
  selectedStatus,
}: Props) => {
  const [couponDetail, setCouponDetail] = useState({
    coupon: "",
    name: "",
    campaign_name: "",
    description: "",
    from_date: "",
    to_date: "",
  });

  useEffect(() => {
    if (couponData) {
      setCouponDetail(couponData);
    }
  }, [couponData]);

  return (
    <Modal
      size="lg"
      fullscreen="lg-down"
      scrollable={true}
      centered
      show={isShow}
      onHide={handleCloseModal}
    >
      <Modal.Header>
        <i className="icon icon-coupon me-1 my-auto" />
        <div className="modal-title h4">คูปองส่วนลด</div>
        <button
          type="button"
          className="btn-close fs-6"
          onClick={handleCloseModal}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <Detail couponDetail={couponDetail} selectedStatus={selectedStatus} />
      </Modal.Body>
    </Modal>
  );
};

export default CouponModal;
